import { controls,grouped } from "../controls";
const workflow_rules = {
label: "Workflow Rules",
pageLabel: "Workflow Rules",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Sequence"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "sequence",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Delay"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "delay",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Role Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "role_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "User Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "user_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Previous Rule Seq"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "previous_rule_seq",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:false, label: "Is Higher Role Allowed", name: "is_higher_role_allowed" }),
...controls.checkBox({ tab: "filter",default:false, label: "Is Ho Allowed", name: "is_ho_allowed" }),
...controls.checkBox({ tab: "filter",default:false, label: "Is Otp", name: "is_otp" }),
...controls.displayText({ tab: "filter", label: "Auth Label"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "auth_label",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Auth Buttons"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "auth_buttons",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "filter", label: "Auth Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "auth_description",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "filter", label: "Auth Fields"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "auth_fields",width:"col-sm-4",maxlength:200}),
]
,form:[
...controls.displayText({ tab: "general", label: "Sequence",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "sequence",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Delay",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "delay",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Role",star:false}),
...controls.oc({ tab: "general", c: "Role", placeHolder: "Role Code", name: "role_code", isRequired:false,fastpath:"roles"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "role_display"}),
...controls.displayText({ tab: "general", label: "User",star:false}),
...controls.oc({ tab: "general", c: "User", placeHolder: "User Code", name: "user_code", isRequired:false,fastpath:"users"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "user_display"}),
...controls.displayText({ tab: "general", label: "Previous Rule Seq",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "previous_rule_seq",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Higher Role Allowed",default:false, name: "is_higher_role_allowed" }),
...controls.checkBox({ tab: "general", label: "Is Ho Allowed",default:false, name: "is_ho_allowed" }),
...controls.checkBox({ tab: "general", label: "Is Otp",default:false, name: "is_otp" }),
...controls.displayText({ tab: "general", label: "Auth Label",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "auth_label",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Auth Buttons",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "auth_buttons",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Auth Description",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "auth_description",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Auth Fields",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "auth_fields",isRequired:true,width:"col-sm-4",maxlength:200}),
]
,history:{
perPage: 10,
reportHeader: "Workflow Rules",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Sequence",accessor: "sequence",},
{Header: "Delay",accessor: "delay",},
{Header: "Role Id",accessor: "role_id",},
{Header: "User Id",accessor: "user_id",},
{Header: "Previous Rule Seq",accessor: "previous_rule_seq",},
{Header: "Is Higher Role Allowed",accessor: "is_higher_role_allowed",type:'tick'},
{Header: "Is Ho Allowed",accessor: "is_ho_allowed",type:'tick'},
{Header: "Is Otp",accessor: "is_otp",type:'tick'},
{Header: "Auth Label",accessor: "auth_label",},
{Header: "Auth Buttons",accessor: "auth_buttons",},
{Header: "Auth Description",accessor: "auth_description",},
{Header: "Auth Fields",accessor: "auth_fields",},
]}};
export default workflow_rules;